import axiosInstance from '../RestClient';

// Payment groups (SHOW_PAYMENT_GROUPS): one collection — a bank transfer —
// applied to several dues of the same account. See routes/paymentGroupRoutes.js.
const BASE_URI = '/payment-groups';

class PaymentGroupService {
	async listForAccount(accountId) {
		const response = await axiosInstance.get(`${BASE_URI}?account=${accountId}`);
		return response;
	}

	async listForDebt(debtId) {
		const response = await axiosInstance.get(`${BASE_URI}?debt=${debtId}`);
		return response;
	}

	async getDetails(groupId) {
		const response = await axiosInstance.get(`${BASE_URI}/${groupId}`);
		return response;
	}

	/** payload: { date, amount?, reference?, paymentMethod?, observations?, allocations: [{ debtDue, amount }] } */
	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async delete(groupId) {
		const response = await axiosInstance.delete(`${BASE_URI}/${groupId}`);
		return response;
	}
}

export default new PaymentGroupService();
